import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/Users/kevin/jenkins/git/media/player-client-gay/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/Users/kevin/jenkins/git/media/player-client-gay/layouts/empty.vue").then(m => m.default || m))
}